// This is the new cookie name for the locale used by translations
export const TRANSLATIONS_LOCALE_COOKIE_NAME = 'i18nLocale';

// This is the old cookie used by i18next, we keep it for backwards compatibility
export const DEPRECATED_TRANSLATIONS_LOCALE_COOKIE_NAME = 'i18next';
